// @ts-nocheck
import React, { useContext } from "react";
import { Controller, useForm, useWatch } from "react-hook-form";
import { Button, Checkbox, Dialog } from "iuvity-ui-components";
import { DialogProps } from "../dialog/CustomDialog";
import { MultiContentDialogProps } from "../dialog/MultiContentDialog";
import { CheckboxChangeParams } from "primereact/checkbox";
import { Dropdown } from "iuvity-ui-components/dist/dropdown";
import {
  ConfigsExportOptions,
  REVALIDATE_FORM_PROPS,
  RELEASE_VERSION_OPTIONS,
} from "../../constants";
import { Environment } from "../../interfaces";
import { AppContext } from "../../context";

interface EnvExporterProps {
  env: Environment;
  envFullName: string;
  exportFn: Function;
  modalController: React.Dispatch<
    React.SetStateAction<MultiContentDialogProps>
  >;
  auxModalController: React.Dispatch<React.SetStateAction<DialogProps>>;
}

export const exporterDefaultValues = {
  ...ConfigsExportOptions.reduce((a, v) => ({ ...a, [v.value]: false }), {}),
  all: false,
};

export const EnvExporter: React.FC<EnvExporterProps> = ({
  env,
  envFullName,
  exportFn,
  modalController,
  auxModalController,
}) => {
  const { t } = useContext(AppContext);

  const versionForm = useForm({
    mode: "onChange",
    delayError: 1200,
    reValidateMode: "onChange",
    defaultValues: {
      version: RELEASE_VERSION_OPTIONS.at(-1)?.value,
    },
  });

  const versionInfo = useWatch({
    control: versionForm.control,
    name: "version",
  });

  const { control, getValues, setValue, reset, watch } = useForm({
    mode: "onChange",
    delayError: 1200,
    reValidateMode: "onChange",
    defaultValues: exporterDefaultValues,
  });

  const formValues = watch();

  const onCancel = () => {
    modalController((prev) => ({
      ...prev,
      visible: false,
      children: null,
    }));
  };

  const onExportApp = async () => {
    const { all, ...rest } = getValues();
    const itemsToExport = Object.fromEntries(
      Object.entries(rest).filter(([_, value]) => value)
    );
    onCancel();
    await exportFn("EXPORT", {
      envFullName,
      appData: {
        appid: env?.applicationid,
        envid: env?.id,
        version: versionInfo,
      },
      itemsToExport,
    });
  };

  const handleModalProps = () => {
    auxModalController((prev) => ({
      ...prev,
      visible: true,
      title: t(`Applications.exportModalTitle`),
      content: `${t(`Applications.exportModalContent`)}`,
      onConfirm: onExportApp,
    }));
  };

  const renderFooter = () => {
    return (
      <div className="flex align-items-center justify-content-center">
        <Button
          label={t("Applications.cancelBtnLabel")}
          onClick={onCancel}
          className="mr-4"
          variant="p-button-link"
        />
        <Button
          label={t("Applications.exportBtnLabel")}
          variant="p-button"
          onClick={handleModalProps}
          disabled={!Object.values(formValues).some((item) => item)}
        />
      </div>
    );
  };

  return (
    <Dialog
      id="dialogScroll1"
      className="dialog-form"
      header={t("Applications.exportApplicationTitle")}
      visible={true}
      onHide={onCancel}
      style={{ width: "50rem" }}
      footer={renderFooter}
    >
      <>
        <div className="flex align-items-center mb-3 gap-2">
          {`Seleccione una versión:`}
          <Controller
            key="version"
            name="version"
            control={versionForm.control}
            render={({ field }) => {
              return (
                <div style={{ width: "15%" }}>
                  {/* @ts-ignore */}
                  <Dropdown
                    className="dropdown"
                    label={""}
                    placeholder={t(`Applications.statusPlaceholder`)}
                    options={RELEASE_VERSION_OPTIONS}
                    filter={false}
                    showClear={false}
                    width="5rem"
                    {...field}
                  />
                </div>
              );
            }}
          />
        </div>

        <span className="mb-5">
          {`${t("Applications.exportApplicationDescripion")} ${envFullName}.`}
        </span>

        <div className="form md mt-5 px-5 gap-3">
          {[
            { label: "selectAllLabel", value: "all" },
            ...ConfigsExportOptions,
          ].map((opt: any) => {
            return (
              <Controller
                key={opt.label}
                name={opt.value}
                control={control}
                render={({ field }) => {
                  return (
                    <div
                      className={`flex align-items-center ${
                        opt.value === "all" ? "mb-2" : "ml-5"
                      }`}
                    >
                      <Checkbox
                        inputId={`checkbox-${opt.label}`}
                        disabled={false}
                        required={false}
                        handleOnChange={function (
                          e: CheckboxChangeParams
                        ): void {
                          if (opt.value === "all") {
                            reset({
                              ...ConfigsExportOptions.reduce(
                                (a, v) => ({ ...a, [v.value]: e.checked }),
                                {}
                              ),
                              all: e.checked,
                            });
                          } else {
                            setValue(
                              opt.value,
                              e.checked,
                              REVALIDATE_FORM_PROPS
                            );

                            const { all, ...rest } = getValues();
                            const allNewValue = Object.values(rest).every(
                              (el) => el === true
                            );

                            if (allNewValue !== getValues("all"))
                              setValue(
                                "all",
                                allNewValue,
                                REVALIDATE_FORM_PROPS
                              );
                          }
                        }}
                        checked={field.value}
                        value={field.value}
                        name={opt.label}
                      />
                      <label htmlFor={`checkbox-${opt.label}`} className="ml-2">
                        {t(
                          `${opt.value === "all" ? "Applications." : "Menu."}${
                            opt.label
                          }`
                        )}
                      </label>
                    </div>
                  );
                }}
              />
            );
          })}
        </div>
      </>
    </Dialog>
  );
};
